import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ItemsModel } from '../models/ItemsModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class ItemsService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getitems(itCode: string , comCode: string) {
      let params = new HttpParams();
        params = params.append("itCode", itCode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<ItemsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Items/GetItems',options);
    }
    public Additems(items: ItemsModel) {
        return this.http.post<ItemsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Items/AddItems', items);
    }

    public delItems(itCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("itCode", itCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<ItemsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Items/Deleteitems',options);
    }

    public getItemsLookup(itCode: string, itTName: string, compCode: string) {
      let params = new HttpParams();
      params = params.append("itCode", itCode);
      params = params.append("itTName", itTName);
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<ItemsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Items/ItemsLookup', options);
  }

    public getItemsLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<ItemsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Items/ItemsLookupTop', options);
  }

  public getItemsLookupCat(itGrouping: string) {
    let params = new HttpParams();
    params = params.append("itGrouping", itGrouping);

    const options = {
        params: params
    };
    return this.http.get<ItemsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Items/ItemsLookupGroup', options);
}
}
